import { useTranslation } from 'react-i18next'

import { cn } from '@/shared/lib/cn'

import { Button, type ButtonProps } from '../Button.tsx'
import { LikeIcon } from './LikeIcon.tsx'

interface LikeIconButtonProps extends ButtonProps {
	onClick: () => void
	isLiked: boolean
	className?: string
}

export const LikeIconButton = ({
	onClick,
	isLiked,
	className,
	...props
}: LikeIconButtonProps) => {
	const { t } = useTranslation('home-page')

	return (
		<Button
			className={cn('group z-0 h-12 w-10', className)}
			variant="flat"
			size="icon-sm"
			aria-label="like-room"
			onClick={onClick}
			data-active={isLiked}
			title={t('like', { ns: 'tooltips' })}
			{...props}
		>
			<LikeIcon />
		</Button>
	)
}
